import { createContext, useContext } from 'react'
import { Colors, ThemedColors } from '../types/Colors'
import { colors, defaultThemedColors } from '../theme/colors'

interface ColorContext {
  colors: Colors
  themedColors: ThemedColors
  changeThemedColors: () => void
  reverseColors: () => void
  isReversedColors: boolean
}

const colorContext = createContext<ColorContext>({
  colors,
  themedColors: defaultThemedColors,
  isReversedColors: false,
  changeThemedColors: () => {
    throw new Error('changeThemedColors should be called inside ColorProvider')
  },

  reverseColors: () => {
    throw new Error('reverseColors should be called inside ColorProvider')
  },
})

export default colorContext

export const useColorContext = () => useContext(colorContext)
